<template>
  <div>
    <b-card>
      <b-row>
        <b-col
          cols="12"
          md="4"
        >
          <product-group />
        </b-col>
        <b-col
          cols="12"
          md="8"
        >
          <title-text />
          <category-what />
<!--          <product-home-page />-->
        </b-col>
        <b-col
          cols="12"
          md="6"
        >
          <summary-text />
        </b-col>
        <b-col
          cols="12"
          md="6"
        >
          <year-text />
        </b-col>
        <b-col
          cols="12"
        >
          <content-text />
<!--          <technical-text />-->
        </b-col>

        <b-col
            cols="12"
            md="4"
        >
          <region-text />
        </b-col>
        <b-col
            cols="12"
            md="4"
        >
          <city-text />
        </b-col>
        <b-col
            cols="12"
            md="4"
        >
          <districts-text />
        </b-col>

        <b-col
          cols="12"
          md="6"
        >
          <product-ordering />
        </b-col>
        <b-col
          cols="12"
          md="6"
        >
          <product-status />
        </b-col>
      </b-row>
    </b-card>
    <b-row>
      <b-col
        cols="12"
        md="6"
      >
        <image-card />
      </b-col>
      <b-col
          cols="12"
          md="6"
      >
        <video-embed />
      </b-col>
      <b-col
        cols="12"

      >
        <photo-gallery />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  BCard, BCol, BRow,
} from 'bootstrap-vue'
import { required } from '@validations'
import ProductGroup from '@/views/Admin/Products/elements/ProductGroup.vue'
import TitleText from '@/views/Admin/Products/elements/TitleText.vue'
import ContentText from '@/views/Admin/Products/elements/ContentText.vue'
// import TechnicalText from '@/views/Admin/Products/elements/TechnicalContent.vue'
import ProductOrdering from '@/views/Admin/Products/elements/ProductOrdering.vue'
import ProductStatus from '@/views/Admin/Products/elements/ProductStatus.vue'
import ImageCard from '@/views/Admin/Products/elements/ImageCard.vue'
import SummaryText from '@/views/Admin/Products/elements/SummaryText.vue'
import PhotoGallery from '@/views/Admin/Products/elements/PhotoGallery.vue'
import VideoEmbed from "@/views/Admin/Products/elements/VideoEmbed.vue"
import ProductHomePage from "@/views/Admin/Products/elements/ProductHomePage.vue"
import CityText from "@/views/Admin/Products/elements/CityText.vue";
import DistrictsText from "@/views/Admin/Products/elements/DistrictsText.vue";
import RegionText from "@/views/Admin/Products/elements/RegionText.vue";
import CategoryWhat from "@/views/Admin/Products/elements/categoryWhat.vue";
import YearText from "@/views/Admin/Products/elements/YearText.vue";

export default {
  name: 'ItemForm',
  components: {
    RegionText,
    CityText,
    VideoEmbed,
    CategoryWhat,
    ProductHomePage,
    YearText,
    BCard,
    BRow,
    BCol,
    ProductGroup,
    TitleText,
    ContentText,
    ProductOrdering,
    ProductStatus,
    ImageCard,
    SummaryText,
    DistrictsText,
    PhotoGallery,
  },
  data() {
    return {
      required,
      imageUrl: this.$store.state.app.baseURL,
      snowOption: {
        theme: 'snow',
      },
    }
  },
  computed: {
    itemData() {
      return this.$store.getters['products/dataItem']
    },
  },
}
</script>
